import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DS_FileUploadForm.html?raw';
import lang from 'dojo/_base/lang';

import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';

import { TabContainer } from "../../../../moreCore/_loadingHelpers/Tabbing";

import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload";
import FileUpload from '../../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import { FileUploadTypes } from "../../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";

class DS_FileUploadForm extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private allowButtons = true;

    private fileUploader: MdsLax<InstanceType<typeof FileUpload>>;

    setup(entity?: any, tabContainer?: MdsLax<InstanceType<typeof TabContainer>>,  node?: HTMLElement) {
        let heading;

        if (entity) {
            this.internalName = "DS_FileUploadFormEditor_Editor_" + entity.ID;
            if (entity.is_new) {
                this.setData(entity);
                heading = this.translate("DigitalSignature_Heading_New_FileUploadFormEditor");
            } else {
                heading = `${this.translate("DigitalSignature_Heading_FileUploadFormEditor")}: ${entity.filename}`;
                entity.is_new = false;
                this.setStartupState("ready");
                this._loadEntity(entity.ID);
            }

        } else {
            this.internalName = "DS_FileUploadFormEditor_Editor_New";
            let newEntity: any = {
                ID: "",
                $Displayname: "",
                Classname: "",
                ClassPrintname: "",
                is_new: true
            }
            this.setData(newEntity);
            heading = this.translate("DigitalSignature_Heading_New_FileUploadFormEditor")
        }

        if (node) {
            this.show("node", heading, null, node)
        } else if (tabContainer) {
            this.show("tab", heading, tabContainer.name);
        }
        else {
            this.show("dlg", heading);
        }

        if(this.allowButtons) this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false, "primary");
    }

    //LOAD
    private _loadEntity(entityId: string): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        this.RequestManager.callfunction(
            "Webtool_API_DigitalSignature__FileUploadForm_LoadEntity",
            { ID: entityId },
            lang.hitch(this, this._onLoadEntityResponse),
            lang.hitch(this, this._onLoadEntityError));
    }

    private _onLoadEntityResponse(response: any): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        response.is_new = false;
        this.setData(response);
    }

    private _onLoadEntityError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
    }

    //SAVE
    private _onClickSave(): void {
        if (!this.checkMandatoryInputs()) {
            this.showToast({
                title: "General_Error_InvalidData",
                iconClass: "fas fa-excalamation-triangle",
            });
            return;
        }

        this.StandbyStart();
        this._deactivateDataButtons(true, true);

        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let isNew = this.getAttributeValue("is_new");
        let changedData = this.getChangedData();
        this.RequestManager.callfunction(
            "Webtool_API_DigitalSignature__FileUploadForm_SaveEntity",
            { ID: entityId, Classname: classname, is_new: isNew, changedData: changedData },
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.emit("saved");
        this.showToast("Editor_Success_Save", "fas fa-check");
        this.close();
        //this._loadEntity(response.entityId);
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Save", "fas fa-warning-triangle");
    }

    //ROLLBACK
    private _onClickRollback(e: MouseEvent): void {
        this.rollback();
    }

    //RELOAD
    private _onClickReload(e: MouseEvent): void {
        let entity = this.getAttributeValue("___root");
        this._loadEntity(entity.ID);
    }

    //DELETE
    private _onClickDelete(e: MouseEvent): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        this.RequestManager.callfunction(
            "Webtool_API_DigitalSignature__FileUploadFormEditor_DeleteEntity",
            { ID: entityId, Classname: classname },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError));
    }

    private _onDeleteResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.close();
        this.showToast("Editor_Success_Delete", "fas fa-check");
    }

    private _onDeleteError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Delete", "fas fa-warning-triangle");
    }


    //BUTTONS
    private _deactivateDataButtons(deactivate: boolean, deactivateAll?: boolean): void {
        this.requestContextButtonDisable("save", deactivate);
        this.requestContextButtonDisable("rollback", deactivate);
        if (deactivateAll) {
            this.requestContextButtonDisable("delete", deactivate);
            this.requestContextButtonDisable("reload", deactivate);
        }
    }

    //STATEFULSECTION
    protected onDirtyChange(newState: boolean) {
        this._deactivateDataButtons(!newState);
        this.setDirtyMarker(newState);
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {

        }
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.setAttributeValue("uploadedFiles", null);

        let isNew = this.getAttributeValue("is_new");
        if (!isNew) {
            if(this.allowButtons) this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete), true, "secondary");
            if (this.allowButtons) this.createDefaultButton("rollback", lang.hitch(this, this._onClickRollback), false, "secondary");
            if (this.allowButtons) this.createDefaultButton("reload", lang.hitch(this, this._onClickReload), true, "primary");
            this.changeInternalName("DS_FileUploadFormEditor_Editor_" + this.getAttributeValue("ID"));
            this.setTitles(`${this.translate("DigitalSignature_Heading_FileUploadFormEditor")}: ${this.getAttributeValue("filename")}`);
        } else {
          
        }
        this._deactivateDataButtons(true);
    }

    //UIFRAMEMIXIN
    //UIFRAMEMIXIN
    _onCloseRequest() {
        let hasChanged = this.isDirty() === true;

        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translate("DigitalSignature_FileUploadFormEditor_AskSavePendingChanges"),
                this.translate("General_PendingChanges") + " - " + this.title,
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.emit("notSaved");
            this.close();
        } else if (result == 0) { // cancel
            this.emit("canceled");
        }
        else {
            this._onClickSave();
            this.on("saved", lang.hitch(this, this.close));
        }
    }

    private _onChangeFileUploader(uploads: FileUploadTypes.UploadUnit[]) {
        //this.setAttributeValue("uploadedFiles", uploads);
        let file = uploads.length > 0 ? uploads[0] : null;
        this.setAttributeValue("uploadedFile", file);
    }

    //WIDGETBASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_DigitalSignature__FileUploadForm_GetSEDConfig";

        this.fileUploader.on("change", lang.hitch(this, this._onChangeFileUploader));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DS_FileUploadForm);